import React from "react";
import i18next from "i18next";
import ReactCountryFlag from "react-country-flag"
import useStyles from "../style/js-style/components/EAFlagStyle"
import { getCountryName } from '../services/common/Utils';

const EAFlag = ({ countryCode, flagWidth = "30px", flagHeight = "30px", noBorder = false, customStyle = null }) => {
  const { classes } = useStyles();

  const calculateWidth = (width) => {
    let str = width.substring(0, width.length - 2);
    let newWidth = str - 6;
    return newWidth + "px";
  };

  return (
    <div className={classes.flagWrapper} style={{ width: calculateWidth(flagWidth), height: flagHeight, overflow: customStyle ? "visible" : "hidden" }}>
      <div className={!customStyle && noBorder ? classes.flagOverlayNoBrder : !customStyle && classes.flagOverlay} style={{ width: flagWidth, height: flagHeight }} />
      <ReactCountryFlag
        countryCode={countryCode}
        svg
        title={getCountryName(countryCode, i18next.language)}
        className={classes.countryFlag}
        style={{ width: flagWidth, height: flagHeight, ...customStyle  }}
      />
    </div>
  )
}

export default EAFlag;
